export default
{
  Securities: [],
  Securitey: {},
  search:{},
}
